import { parseFillGradient, parseFillMode, parseObjectGlow, parseObjectShadow, } from './objectVisualStyle';
export function parseTextBody(body) {
    if (!body)
        return {};
    try {
        const parsed = JSON.parse(body);
        if (parsed && typeof parsed === 'object') {
            parsed.fillMode = parseFillMode(parsed.fillMode) ?? parsed.fillMode;
            parsed.fillGradient = parseFillGradient(parsed.fillGradient) ?? parsed.fillGradient;
            parsed.shadow = parseObjectShadow(parsed.shadow) ?? parsed.shadow;
            parsed.glow = parseObjectGlow(parsed.glow) ?? parsed.glow;
            return parsed;
        }
    }
    catch {
        // legacy plain-text body
    }
    return { content: body };
}
export function textBodyFromSceneObject(obj) {
    const data = { content: obj.name };
    if (obj.fontSize != null)
        data.fontSize = obj.fontSize;
    if (obj.textAlign != null)
        data.textAlign = obj.textAlign;
    if (obj.fill != null)
        data.fill = obj.fill;
    if (obj.fillMode != null)
        data.fillMode = obj.fillMode;
    if (obj.fillGradient != null)
        data.fillGradient = obj.fillGradient;
    if (obj.shadow != null)
        data.shadow = obj.shadow;
    if (obj.glow != null)
        data.glow = obj.glow;
    return data;
}
export function serializeTextBody(data) {
    return JSON.stringify(data);
}
const MIN_TEXT_FONT_SIZE = 3;
const MAX_TEXT_FONT_SIZE = 200;
/**
 * Text kutusu resize edilirken punto, yükseklik oranıyla büyür veya küçülür.
 * En-boy oranı açıkken her tutamaç yüksekliği de değiştirdiği için yazı kutuyla birlikte ölçeklenir.
 * Yükseklik aynı kaldıysa (yalnızca genişlik) punto korunur; satır yeniden akar.
 */
export function fontSizeForTextResize(startFontSize, startHeight, nextHeight) {
    const base = startFontSize > 0 ? startFontSize : 16;
    if (!(startHeight > 0) || !(nextHeight > 0))
        return base;
    const next = Math.round(base * (nextHeight / startHeight));
    return Math.max(MIN_TEXT_FONT_SIZE, Math.min(MAX_TEXT_FONT_SIZE, next));
}
export function resolveTextFieldsFromBody(type, body, fallbackName) {
    if (type !== 'text')
        return {};
    const parsed = parseTextBody(body);
    return {
        name: parsed.content ?? fallbackName ?? 'Text',
        fontSize: parsed.fontSize,
        textAlign: parsed.textAlign,
        fill: parsed.fill,
        fillMode: parsed.fillMode,
        fillGradient: parsed.fillGradient,
        shadow: parsed.shadow,
        glow: parsed.glow,
    };
}
export function isFillNone(objOrFill) {
    if (objOrFill == null)
        return false;
    if (typeof objOrFill === 'string')
        return objOrFill === 'none';
    if (objOrFill.fillMode === 'none')
        return true;
    if (objOrFill.fillMode === 'solid' || objOrFill.fillMode === 'gradient')
        return false;
    return objOrFill.fill === 'none';
}
export function isBorderNone(obj) {
    if ((obj.strokeStyle ?? 'solid') === 'none' || (obj.strokeWidth ?? 2) <= 0)
        return true;
    const sides = obj.strokeSides;
    if (!sides)
        return false;
    return !sides.top && !sides.right && !sides.bottom && !sides.left;
}
